import { projectData } from "@domain/project/projectData";

// Budget category IDs that scale with expansion square footage
export const variableCategoryIds = new Set([5, 6, 7, 8, 9, 10, 11, 13, 26]);

// Override costs for Plan B where we have actual data
export const planBOverrides = {
  7: { estimated: 11000, notes: "Reduced — oven stays in current position (existing circuit), cooktop shifts ~1m, audio wiring relocation still needed" },
  8: { estimated: 11500, notes: "Increased — sink moves north + west from current location, longer plumbing runs than Plan A" },
  12: { estimated: 16095, notes: "KZ Kitchen estimate #E409349 — Slim Shaker Nebula White perimeter + Matte Black island, European frameless, pre-assembled boxes, includes trash pullout, excludes appliances/handles/lighting/countertops (quartz sourced separately)" },
  17: { estimated: 706, notes: "Under-cabinet LED lighting — KZ has LED line but not yet quoted, using prior IKEA estimate as placeholder" },
  29: { estimated: 0, notes: "Pantry eliminated — storage replaced by tall cabinets (double oven pantry tower in KZ quote)" },
};

export const planBSqFt = 330.6;
export const planBTotalSqFt = 723.4;
export const planBName = "Plan B — Reduced Expansion";

export const planBSpaces = [
  { name: "Great Room (Existing)", sqFt: 392.8 },
  { name: "Kitchen Expansion", sqFt: 330.6 },
];

export function buildPlanB(budget) {
  const ratio = planBSqFt / projectData.expansionSqFt;
  return budget.map((cat) => {
    if (planBOverrides[cat.id]) {
      return { ...cat, ...planBOverrides[cat.id] };
    }
    if (variableCategoryIds.has(cat.id)) {
      return { ...cat, estimated: Math.round(cat.estimated * ratio) };
    }
    return cat;
  });
}
